import { useStyles, Flex } from '@archipro-design/aria';
import { NavLink, useLocation } from '@remix-run/react';

import * as S from './CategoryNavigation.style';
import type { CategoryNavigationProp } from './CategoryNavigation';
import { CheckLine } from '@archipro-design/icons';
import classNames from 'classnames';

const CategoryNavigationDesktop: React.FC<CategoryNavigationProp> = ({
    navItems,
}) => {
    const { css } = useStyles();
    const location = useLocation();

    return (
        <Flex className={css(S.Container)} hAlign="start" vAlign="center">
            <Flex className={css(S.Nav)}>
                {navItems.map((navItem, i) => (
                    <div
                        className={classNames(
                            css(S.NavContainer),
                            'articles-Nav_NavContainer',
                        )}
                        key={`articles-Nav__NavContainer-${i}`}
                    >
                        <NavLink
                            prefetch="intent"
                            className={classNames(
                                css(S.NavItem),
                                'articles-Nav__NavLink',
                                {
                                    active:
                                        navItem.link !== '/articles' &&
                                        location.pathname.includes(
                                            navItem.link,
                                        ),
                                },
                            )}
                            to={navItem.link}
                            end={true}
                            preventScrollReset={true}
                        >
                            {navItem.title}
                        </NavLink>
                        {navItem.children && navItem.children.length > 0 && (
                            <ul
                                className={classNames(
                                    css(S.SubNavList),
                                    'articles-Nav__SubNavList',
                                )}
                            >
                                {navItem.children.map((child, i) => (
                                    <li
                                        className={css(S.SubNavListItem)}
                                        key={`articles-NavItemChildren__NavListItem-${i}`}
                                    >
                                        <NavLink
                                            className={css(S.SubNavLink)}
                                            prefetch="intent"
                                            to={child.link}
                                            end={true}
                                            preventScrollReset={true}
                                        >
                                            {child.title}
                                        </NavLink>
                                        <CheckLine
                                            className={css(
                                                S.SubNavLinkActiveIcon,
                                            )}
                                        />
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </Flex>
        </Flex>
    );
};

export default CategoryNavigationDesktop;
